import { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useKotContext } from "../context/kotContext";
//import { useKotContext } from '../context/kotContext';

const UseKotPrint = (arr1, tableNo, totalAmount, generateKotNo, nc) => {
  const { updateKotNo, fetchServerName, serverName } = useKotContext();
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [kotBill, setKotBill] = useState([]);
  console.log(nc, "kotBill.nc4");

  //console.log(generatekotNo,'generateKotNo')
  const [kotData, setKotData] = useState({
    foodItem: arr1 || [],
    tableNo: tableNo || "",
    kotNo: "",
    totalBilling: totalAmount || 0,
    serverName: serverName,
    nc: nc || false,
  });
  //console.log(kotData,'kotData.nc1')

  const customerId = localStorage.getItem("customerId");

  const getFormattedCurrentDate = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    let hours = now.getHours();
    let minutes = String(now.getMinutes()).padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}${period.toLowerCase()}`;
    return [
      formattedDate,
      `${day}-${month}-${year}`,
      `${hours}:${minutes} ${period}`,
    ];
  };

  useEffect(() => {
    fetchServerName(customerId, tableNo);
    const [_, formattedDate, formattedTime] = getFormattedCurrentDate();
    setDate(formattedDate);
    setTime(formattedTime);
  }, [customerId, tableNo]);
  useEffect(() => {
    setKotData((prev) => ({
      ...prev,
      serverName: serverName, // this gets updated from context
    }));
  }, [serverName]);
  const kotPrint = async () => {
    try {
      // const randomKotNumber = `${tableNo}-${Math.floor(Math.random() * 10000)}`;

      // Update KOT data
      const updatedKotData = {
        ...kotData,
        foodItem: arr1,
        kotNo: generateKotNo,
        totalBilling: totalAmount,
        nc: nc, // Ensure nc is passed here correctly
        serverName: serverName,
      };
      console.log(updatedKotData, "updatedKotData");
      //setKotData(updatedKotData);

      updateKotNo(customerId, generateKotNo, tableNo);

      // POST to backend
      const response = await axios.post(
        "https://api.rasoi.launchlysoftware.in/api/kotBillRegister",
        {
          customerId,
          data: updatedKotData,
        },
      );

      toast.success(response.data.message);

      // Split food items
      const mainFoodItem = updatedKotData.foodItem.filter(
        (item) =>
          ![
            "bottle",
            "30ml peg",
            "60ml peg",
            "60ML",
            "60 ML",
            "30ML",
            "30 ML",
            "60ml",
            "60 ml",
            "30ml",
            "30 ml",
          ].some((keyword) => item.name.toLowerCase().includes(keyword)),
      );
      const specialItems = updatedKotData.foodItem.filter((item) =>
        [
          "bottle",
          "30ml peg",
          "60ml peg",
          "60ML",
          "60 ML",
          "30ML",
          "30 ML",
          "60ml",
          "60 ml",
          "30ml",
          "30 ml",
        ].some((keyword) => item.name.toLowerCase().includes(keyword)),
      );

      const generateTable = (items) => `
        <table>
          <thead>
            <tr>
              <td class="name">Name</td>
              <td class="quantity">Quantity</td>
            </tr>
          </thead>
          <tbody>
            ${items
              .map(
                (item) => `
                <tr>
                  <td class="name">${item.name}${
                  item.note ? ` (${item.note})` : ""
                }</td>
                  <td class="quantity">${item.quantity}</td>
                </tr>
              `,
              )
              .join("")}
          </tbody>
        </table>
      `;

      const printSection = (title, items) => `
<style>
  @page {
    size: 72mm auto; /* 3in ≈ 72mm, matches thermal paper width */
    margin: 0; /* no extra margins */
  }
  body {
    width: 100%;
    margin: 0;
    font-size: 12px;
  }
  h2 {
    font-size: 12px;
    margin-bottom: 10px;
  }
  p {
    margin: 3px 0;
    font-size: 10px;
  }
  table {
    width: 100%; /* use full width so columns don't get squashed */
    border-collapse: collapse;
    font-size: 10px;
  }
  td {
    padding: 3px;
    border: 1px solid #000;
    word-break: break-word; /* wrap long names instead of cutting */
  }
  td.name {
    width: 80%;
  }
  td.quantity {
    width: 20%;
    text-align: center;
  }
</style>
<body>
  <h2>${title}</h2>
  <p>Table No.: ${updatedKotData?.tableNo}</p>
  <p>KOT No.: ${updatedKotData?.kotNo}</p>
  <p>Server: ${updatedKotData?.serverName}</p>
  <p>Date: ${date}</p>
  <p>Time: ${time}</p>
  ${generateTable(items)}
</body>
`;

      if (mainFoodItem.length > 0) {
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.top = "-9999px";
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(printSection("Main Food Items", mainFoodItem));
        doc.close();

        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => document.body.removeChild(iframe), 1000);
      }

      if (specialItems.length > 0) {
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.top = "-9999px";
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(printSection("Special Items", specialItems));
        doc.close();

        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => document.body.removeChild(iframe), 1000);
      }

      //setTimeout(() => window.location.reload(), 2000);
    } catch (error) {
      console.error("Error saving KOT:", error);
      toast.error("Error in KOT");
    }
  };

  return kotPrint;
};

export default UseKotPrint;
